<template>
  <div class="flex content-center justify-between w-full h-16 px-5 py-4 text-white md:px-24 bg-sc-blue">
    <div class="text-left">
      <a
        class="flex-shrink-0"
        href="/"
      >
        <img
          class="hidden md:block"
          :src="require('@assets/images/logo-white.svg')"
        >
        <img
          class="block md:hidden"
          :src="require('@assets/images/logo-white-small.svg')"
        >
      </a>
    </div>
    <div class="self-center text-right">
      <button
        @click="showDropdown()"
        v-if="entities.length"
        class="px-4 py-2 rounded bg-sc-blue-light hover:text-white hover:border-transparent"
        ref="entities-dropdown"
      >
        {{ dropDownTitle }}
        <img
          :src="require('@assets/images/chevron-down.svg')"
          class="inline ml-2"
        >
      </button>
      <a
        v-else
        ref="create new entity"
        href="/entities/new"
        class="px-4 font-semibold bg-transparent rounded hover:bg-secondary hover:text-white hover:border-transparent"
      >
        Crear Supercartola
      </a>
    </div>
    <div
      v-if="toggleDropdown"
      @click="hideDropdown()"
      class="fixed inset-0 z-10 w-full h-full cursor-default"
    />
    <div
      v-if="toggleDropdown"
      class="absolute right-0 z-20 w-64 pt-2 mt-10 ml-1 mr-24 bg-white rounded shadow-sc-dropdown"
    >
      <div
        v-for="entity in otherEntities"
        :key="entity.id"
        @click="hideDropdown()"
      >
        <a
          :href="`/entities/${entity.id}/bank_movements`"
          class="flex flex-row items-start py-1 pl-4 mx-2 rounded hover:bg-sc-gray-lighter"
          :ref="`entity-${entity.id}`"
          @click="resetSessionFilters"
        >
          <img
            :src="require('@assets/images/home.svg')"
            class="mt-1"
          >
          <div class="ml-2">
            <p
              class="text-sm text-primary"
            >{{ entity.name }}</p>
          </div>
        </a>
      </div>

      <button
        ref="create-entity-button"
        v-show="!toggleInput"
        @click="showInput()"
      >
        <div class="flex flex-row py-1 pl-4 m-2 text-sm rounded w-60 text-primary hover:bg-sc-gray-lighter">
          <img :src="require('@assets/images/plus.svg')">
          <p
            class="ml-2"
          >
            {{ $t('message.navbar.createEntity') }}
          </p>
        </div>
      </button>
      <div
        v-show="toggleInput"
        class="flex flex-row w-auto px-4 py-1 m-2 space-x-5 text-sm rounded text-primary"
      >
        <input
          ref="input"
          v-model="newEntityName"
          class="w-full tracking-wide border-b outline-none border-sc-gray-light text-primary"
          placeholder="Nombre de la supercartola"
        >
        <button
          ref="input-button"
          class="flex-none p-1 ml-4 rounded shadow-sc-button"
          @click="createNewEntity()"
        >
          <img
            :src="require('@assets/images/done.svg')"
            width="16"
          >
        </button>
      </div>
      <div class="border-t border-solid border-sc-gray-light" />
      <a
        class="block py-3 pl-4 mx-2 text-sm text-primary"
        href="/users/sign_out"
      >
        {{ $t('message.navbar.logout') }}
      </a>
    </div>
  </div>
</template>
<script>
import EntitiesApi from '../api/entities';

export default {
  data() {
    return {
      toggleDropdown: false,
      toggleInput: false,
      newEntityName: '',
      chatwootLoaded: false,
    };
  },
  props: {
    entities: {
      type: Array,
      default: null,
    },
    currentEntity: {
      type: Object,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
  },
  computed: {
    otherEntities() {
      return this.currentEntity ?
        this.entities.filter((entity) => entity.id !== this.currentEntity.id) :
        this.entities;
    },
    dropDownTitle() {
      return this.currentEntity ? this.currentEntity.name : 'Tus Supercartolas';
    },
    currentUser() {
      return this.$store.state.users.currentUser;
    },
  },
  methods: {
    resetSessionFilters() {
      window.sessionStorage.removeItem('filters');
    },
    showInput() {
      this.toggleInput = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    hideDropdown() {
      this.toggleInput = false;
      this.toggleDropdown = false;
      this.newEntityName = '';
    },
    showDropdown() {
      this.toggleDropdown = true;
    },
    async createNewEntity() {
      const response = await EntitiesApi.createEntity(this.newEntityName);
      this.hideDropdown();
      window.location.href = `/entities/${response.data.entity.id}/bank_accounts`;
    },
    identifyUser() {
      window.$chatwoot.setUser(this.currentUser.email, {
        email: this.currentUser.email,
        name: this.currentUser.firstName,
      });
    },
  },
  watch: {
    currentUser(newVal) {
      if (newVal && this.chatwootLoaded) {
        this.identifyUser();
      }
    },
    chatwootLoaded(value) {
      if (value && this.currentUser) {
        this.identifyUser();
      }
    },
  },
  async beforeMount() {
    window.addEventListener('chatwoot:ready', () => {
      this.chatwootLoaded = true;
    });
  },
};
</script>
